export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6203.64dc6168.jpg";